// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import {
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Accets
import { apiService } from 'services/ApiService';
import { getInitials, formatDateWithSuffix, validateLoadMore, parseNotifyDate } from 'services/Utils';
import { ReactComponent as TransactionIcon } from 'assets/svg/transaction-history-3.svg';
import { ReactComponent as EmptyListNotifications } from 'assets/svg/empty-list-notifications.svg';

// Components
import Card from 'components/Card/Card';

const WithdrawTransactions = ({ userData }) => {
  const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
  const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');

  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const limit = 10;
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [dataMeta, setDataMeta] = useState(); 
  useQuery({
      queryKey: ['withdrawals-transactions', offset],
      queryFn: async () => {
        if(!localStorage.getItem('auth')) { return true; }

        const response = await apiService.getWithdrawals({ limit, offset });
        if(offset === 0){
            setData(response.data);
        } else {
            setData([...data, ...response.data]);
        }
        setDataMeta(response.meta);
        return true;
      },
      refetchOnWindowFocus: false
  });

  const loadMore = async () => {
      setOffset(offset + limit);
  };

  return (
  	<>
    	{ data.length > 0 ? (
		    <Card padding="12px 0 12px 12px" borderRadius="12px" border={border} boxShadow={boxShadow}>	    
			    { data.map((item, index) => (
			        <Flex key={index} p="0" mt="12px" gap="20px" alignItems="center" w="100%">
			          <Box p="4px" w="32px" h="32px" borderRadius="8px" bg="rgba(9, 155, 255, 0.10)" position="relative">
			            <TransactionIcon fontSize="24px" />
			          </Box>

			          <Flex borderBottom={border} pb="10px" w="100%" justifyContent="space-between">
			          	<Box>
			          		<Text variant="text-md" fontSize="13px" mb="3px" color={ isDark ? '#9FABCB' : '#262D47' }>
			          			Status: <Text 
			          				as="span" 
			          				variant="text-md" 
			          				fontSize="13px"
			          				color={ item?.status === 'processed' ? 
			          					'#FFB91B' : item?.status === 'approved' ? 
			          					'#57D175' : '#FF6C64' } 
			          				textTransform="capitalize">
			          			{item?.status}</Text>
			          		</Text>
				            <Text 
				            	variant="title-md" 
				            	fontWeight="700" 
				            	textTransform="capitalize"
				            	mb="3px">
				            	{item?.service}
				            </Text>
				            <Text 
				              fontSize="15px" 
				              w="100%" 
				              textTransform="capitalize"
				              overflow="hidden" 
				              display="-webkit-box" 
				              style={{
				                WebkitLineClamp: 2, 
				                WebkitBoxOrient: 'vertical',
				                textOverflow: 'ellipsis'
				              }}
				            >
				              {item?.description}
				            </Text>
				            <Text mt="3px" variant="text-xs" color={ isDark ? '#9FABCB' : '#262D47' }>{parseNotifyDate(item?.createdAt)}</Text>
			            </Box>

			            <Text 
			            	variant="title-md"
			            	color={ item?.status === 'pending' ? 
	          					'#FFB91B' : item?.status === 'approved' ? 
	          					'#57D175' : '#FF6C64' } 
			            	pr="8px">${item?.amount ? item?.amount / 100 : 0}</Text>
			          </Flex>


			        </Flex>
			    ))}

			    { validateLoadMore(data, dataMeta) && (
			        <Button variant="ghost-md" maxW="220px" onClick={loadMore} m="24px auto !important" display="block">
			          Load More
			        </Button>
			    )}
		    </Card>
	    ) : (
	    	<Box 
              textAlign="center" 
              py="40px" 
              maxW={{sm: '325px'}} 
              left="50%" 
              position="relative" 
              transform="translate(-50%, 0px)">
                <Text variant="title-md" fontSize="20px" mt="20px" pb="9px" letterSpacing="-0.4px">Transaction list is empty</Text>
                <Text>We’ll let you know when there will be something to update you</Text>
            </Box>
	    )}
    </>
  );
};

export default WithdrawTransactions;